import React from "react";
import AggregateTable from "../../Tables/Portfolio/AggregateTable";
import useSearchParam from "../../Hooks/useSearchParam";
import { IPortfolioSearchParams } from "../../Interfaces/portfolio";
import UsersDropdown from "../../Components/Dropdown/Users/UsersDropdown";
import DynamicDropdown from "../../Components/Dropdown/DynamicDropdown";
import Button from "../../Components/Button";
import PortfoTable from "../../Tables/Portfolio/PortfoTable";
import { getUsers } from "../../Requests/portfolioRequests";

interface IProps {
  aggregateFlag: boolean;
  setAggregateFlag: (flag: boolean) => void;
  portfoFlag: boolean;
  setPortfoFlag: (flag: boolean) => void;
}

const PortfoAggregateWrapper = ({
  aggregateFlag,
  setAggregateFlag,
  portfoFlag,
  setPortfoFlag,
}: IProps) => {
  const {
    clientSearchParamChangeHandler,
    clientSearchParams,
    onSubmit,
    serverSearchParams,
  } = useSearchParam({ initialSearchParam: {} as IPortfolioSearchParams });

  return (
    <div className="flex flex-col justify-start items-start gap-2 w-full">
      <div className="flex flex-row justify-start items-center gap-2">
        <div className="w-[250px]">
          <DynamicDropdown
            dropdown={{
              name: "accountId",
              placeholder: "نام اکانت",
            }}
            getData={getUsers}
            onChange={clientSearchParamChangeHandler}
            value={clientSearchParams.accountId}
          />
        </div>
        <div className="w-min">
          <Button onClick={onSubmit} text="جستجو" variant="contained" />
        </div>
      </div>
      <AggregateTable
        refreshFlag={aggregateFlag}
        onFetchComplete={() => setAggregateFlag(false)}
      />
      <PortfoTable
        searchParams={serverSearchParams}
        refreshFlag={portfoFlag}
        onFetchComplete={() => setPortfoFlag(false)}
      />
    </div>
  );
};

export default PortfoAggregateWrapper;
